import React from "react";
import { Row, Col,Image } from "antd";

export default function CateringTemplate({ data ,formFieldsdata,eventsData}) {
  return (
    <div style={{ padding: 20 }}>
      <Row>
        <Col xs={24} lg={12} className="template-heading">
          Catering Page
        </Col>
      </Row>
      <Row
        className="items-center"
        style={{ backgroundColor: "#F4F1F1", padding: 36, marginTop: 40 }}
      >
        <Col xs={24} lg={12} style={{ padding: 20 }}>
          <div className="template-heading text-left">{ 'Catering Form'}</div>
          {eventsData?.filter(item => formFieldsdata?.catering_event_type_ids?.includes(item.id)).map((item) => (

          <div
            style={{ fontSize: 14, marginTop: 30, opacity: 0.6 }}
            className="text-left"
          >
            {item.name}
           
          </div> ))}
        </Col>
        <Col span={12} className="items-center justify-center">
          <div
            className="d-flex items-center justify-center"
            style={{ backgroundColor: "#C4C4C4", width: 216, height: 367 }}
          >
           <Image width={200} src={formFieldsdata?.catering_banner_image_url} />
          </div>
        </Col>
      </Row>
    </div>
  );
}
